/**
 * WuaPlusCancel — landing when the buyer cancels Stripe checkout.
 * Kept intentionally small: a friendly reminder, one CTA to retry,
 * one CTA to browse the free tools.
 */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, RefreshCw } from "lucide-react";

export default function WuaPlusCancel() {
  return (
    <div
      data-testid="wua-plus-cancel-page"
      className="max-w-2xl mx-auto px-6 lg:px-10 py-16 text-center"
    >
      <h1 className="font-editorial text-3xl text-[#002147]">
        Payment cancelled — no charge made.
      </h1>
      <p className="mt-4 text-stone-600 text-[14px] leading-relaxed">
        We didn't charge your card. If Stripe glitched or the checkout
        page didn't feel right, restart the flow below. The whole
        pipeline (payment → Claude-generated report) usually takes 45
        seconds end-to-end.
      </p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Button
          data-testid="wua-plus-cancel-retry"
          asChild
          className="bg-[#4C1D95] hover:bg-[#3B0764] text-white rounded-md"
        >
          <Link to="/plus"><RefreshCw className="h-4 w-4 mr-1.5" /> Try again</Link>
        </Button>
        <Button
          asChild
          variant="outline"
          className="rounded-md"
          data-testid="wua-plus-cancel-home"
        >
          <Link to="/"><ArrowLeft className="h-4 w-4 mr-1.5" /> Back to WUA</Link>
        </Button>
      </div>
    </div>
  );
}
